t = require('views/internal/teacup-with-helpers')('header_channel_picker')

module.exports = t.renderable ({ cookie, channels, dev, version, tests }) ->
  if cookie
    t.p ->
      t.format 'you-have-a-version-cookie-set-this-is-a-feature-intended-for-client-developers-and-testers-and-will-prevent-you-from-changing-channels'

    t.input '.js-remove-cookie.wide.primary', { type: 'button', value: t.l('remove-cookie') }
  else
    t.ul '.pop-over-list', ->
      for channel in channels
        t.li ->
          t.a '.js-select', { href: '#', name: channel.name }, ->
            t.text channel.displayName
            if channel.active
              t.icon 'check'
      if dev
        t.hr()
        t.li ->
          t.a '.js-select-dev', { href: '#' }, ->
            t.format 'pick-a-version'

  t.hr()

  t.pre { style: 'margin-bottom: 0;' }, ->
    t.text version

  if tests
    t.hr()
    t.p -> t.format 'listed-below-are-experiments'
    t.p -> t.format 'below-the-experiment'
    t.button {
      class: t.classify({
        negate: true
        'button-link': true,
        'header-experiment-remove-btn': true,
        'js-remove-all-exps': true
      })
    }, ->
      t.format 'remove-all-experiments'
    t.ul '.pop-over-list.header-experiment-list', ->
      for test in tests
        t.li ->
          t.a '.js-view-exp-details', { href: '#', 'data-name': test.name }, ->
            t.text test.name
            if test.inExperiment
              t.span '.sub-name', -> t.text ":: #{test.selectedVariation}"
            else
              t.span '.sub-name', -> t.format 'not-in-experiment'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_channel_picker.coffee